<template>
  <section class="intro">
    <div>
      <div>
        <article class="default-text">
          <h1>{{ introTitle }}</h1>
          <div v-html="introContent" />
        </article>
      </div>
      <div>
        <img
          :src="introPhoto"
          alt=""
        >
        <ul class="counter">
          <!-- Render the required stats -->
          <li
            v-for="(stat, index) in requiredStats"
            :key="'required-' + index"
          >
            <p>{{ stat.value }}</p>
            <p>{{ stat.label }}</p>
          </li>
          <!-- Render any additional optional stats -->
          <li
            v-for="(stat, index) in optionalStats"
            :key="'optional-' + index"
          >
            <p>{{ stat.value }}</p>
            <p>{{ stat.label }}</p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useMicrositeStore } from '../../stores/useMicrositeStore'

const store = useMicrositeStore()

// Intro title and content from the microsite store.
const introTitle = computed(() => store.microsite?.introTitle)
const introContent = computed(() => store.microsite?.introContent)
const introPhoto = computed(() => {
  const url = store.microsite?.introPhoto
  if (url) {
    return url.replace('/media/', '/media/cache/intro_image/')
  }
  return '/images/intro-placeholder.webp'
})

// Build required stats array from the new fields.
const requiredStats = computed(() => [
  {
    label: store.microsite?.introNumber1Label,
    value: store.microsite?.introNumber1Value
  },
  {
    label: store.microsite?.introNumber2Label,
    value: store.microsite?.introNumber2Value
  }
])

// Build optional stats only if the label exists.
const optionalStats = computed(() => {
  const stats: Array<{ label: string; value: string }> = []
  if (store.microsite?.introNumber3Label) {
    stats.push({
      label: store.microsite.introNumber3Label,
      value: store.microsite.introNumber3Value || ''
    })
  }
  if (store.microsite?.introNumber4Label) {
    stats.push({
      label: store.microsite.introNumber4Label,
      value: store.microsite.introNumber4Value || ''
    })
  }
  return stats
})
</script>
